import { ajaxAuth } from "@tm/utils"
import { WebserviceUrl } from "../../webserviceUrls"

export function showCompilationEmbeddedPdf(compilationId: string) {
    const url = `${WebserviceUrl.CompilationsArticleCompilationsEmbedded}/CompilationShowPdf`
    const body = { compilationId }

    return ajaxAuth<number[]>({ url, body, responseType: "blob" })
}
